import { SplitColumnsContainer } from '@startlibs/components'
import { Combobox, DatePicker, FormValue, TextInput } from '@startlibs/form'
import { getColor } from '@startlibs/utils';
import React from 'react'
import styled from 'styled-components';
import { Card, SectionHeading } from '../../components/PageLayout';
import {FormattedMessage, useIntl} from 'react-intl'
import { ComboboxContainer } from './ContactDetails';
import { FEMALE, MALE, NONBINARY, OTHER } from '../../enums/Gender'
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector'
import { getFormattedStates } from '../PatientAndContactDetails';
import { InfoBox } from '../../components/InfoBox';
import { lazyProviderInfo } from '../../components/WithProvider';
import {defaultDateFormat} from "../../utils/dateFormat";
// import {useRecentlySaved} from '../associates/hooks/RecentlySaved'

export const AddressHeading = styled.div`
  font-size: 13px;
  color: ${getColor('gray150')};
  padding-bottom: .25rem;
  border-bottom: 1px solid ${getColor('gray210')};
  margin: 1.5rem 0;
`

export const StyledCountryDropdown = styled(CountryDropdown)`
  width: 100%;
  font-size: 14px;
  border: 1px solid #d2d2d2;
  border-radius: 6px;
  color: #3c3c3c;
  background: white;
  position: relative;
  line-height: 34px;
  display: block;
  height: 3rem;
  padding: 0 2.25rem 0 0.7rem;
  overflow: auto;
  outline: 0;
  outline: none;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  
  &:focus {
    border-color: ${getColor('gray180')};
    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);
  }
`
export const StyledRegionDropdown = styled(RegionDropdown)`
  width: 100%;
  font-size: 14px;
  border: 1px solid #d2d2d2;
  border-radius: 6px;
  color: #3c3c3c;
  background: white;
  position: relative;
  line-height: 34px;
  display: block;
  height: 3rem;
  padding: 0 2.25rem 0 0.7rem;
  overflow: auto;
  outline: 0;
  outline: none;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  
  &:focus {
    border-color: ${getColor('gray180')};
    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);
  }
`
export const StyledRegionsDiv = styled.div`
position: relative;
margin-bottom: 1rem;
text-align: left;
  label {
    font-weight: 500;
    display: inline-block;
    font-size: 14px;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
`

const VIEWPORT_MIN_WIDTH = 500

export const PatientDetails = ({ readOnly, isAdmin, form, countryList, showSelects, acceptedJurisdictions, isPatientCreating=false}) => {
  const intl = useIntl()
  const providerInfo = lazyProviderInfo.read()
  const captchaEnabled = providerInfo.captchaEnabled

  const INTL_GENDER_LABELS = (intl) => ({
    M: intl.formatMessage({defaultMessage:"Male",description:"Gender label: male"}),
    F: intl.formatMessage({defaultMessage:"Female",description:"Gender label: female"}),
    O: intl.formatMessage({defaultMessage:"Other",description:"Gender label: other"}),
    N: intl.formatMessage({defaultMessage:'Non-binary',description:"Gender label: non-binary"})
  })

  return <>
    <SectionHeading><h3>
      {
        <FormattedMessage
          defaultMessage='{isAdmin, select, true {Patient} false {Patient details} other {}}'
          description='PatientDetails title'
          values={{ isAdmin }}
        />
      }</h3></SectionHeading>
    <Card css="padding-bottom:1.5rem;">
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.firstName"
          label={intl.formatMessage({ defaultMessage: "First name", description: "PatientDetails firstName label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: John", description: "PatientDetails firstName placeholder" })}
          maxLength={255}
          mandatory
        />
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.middleName"
          label={intl.formatMessage({ defaultMessage: "Middle name", description: "PatientDetails middleName label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: James", description: "PatientDetails middleName placeholder" })}
          maxLength={255}
        />
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.lastName"
          label={intl.formatMessage({ defaultMessage: "Last name", description: "PatientDetails lastName label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: Doe", description: "PatientDetails lastName placeholder" })}
          maxLength={255}
          mandatory
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <DatePicker
          disabled={readOnly}
          weekStartsMonday
          label={intl.formatMessage({ defaultMessage: "Date of birth", description: "Date of birth label" })}
          placeholder={intl.formatMessage({
            defaultMessage:`Ex: {dateFormat}`,
            description:"Patient login, date of birth placeholder"
          },{dateFormat:defaultDateFormat(intl).toUpperCase()})}
          format={defaultDateFormat(intl)}
          path="patientInfo.dob"
          mandatory
        />
        <ComboboxContainer readOnly={readOnly} className='fs-exclude'><Combobox
          disabled={readOnly}
          className="combobox fs-exclude"
          placeholder={intl.formatMessage({ defaultMessage: "Please select", description: "PatientDetails gender placeholder" })}
          path='patientInfo.gender'
          options={[MALE, FEMALE, NONBINARY, OTHER]}
          label={intl.formatMessage({ defaultMessage: "Gender", description: "PatientDetails gender label" })}
          getLabel={v => {
            return INTL_GENDER_LABELS(intl)[v]
          }}
          mandatory
        /></ComboboxContainer>

        {/* <RadioboxGroup disabled={readOnly} mandatory label="Gender" horizontal path="patientInfo.gender" framedBoxes wide>
          <SimpleRadiobox fieldValue="M" label="Male" className='fs-exclude'/>
          <SimpleRadiobox fieldValue="F" label="Female" className='fs-exclude'/>
          <SimpleRadiobox fieldValue="O" label="Other" className='fs-exclude'/>
        </RadioboxGroup> */}
      </SplitColumnsContainer>
      <AddressHeading>
        <FormattedMessage
          defaultMessage='Patient mailing address'
          description='PatientDetails address heading'
          values={{ isAdmin }}
        />
      </AddressHeading>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        {showSelects ? <>
          <ComboboxContainer readOnly={readOnly} className='fs-exclude'><Combobox
            // withWindowing={true}
            disabled={readOnly}
            className="combobox fs-exclude"
            label={intl.formatMessage({ defaultMessage: "Country", description: "PatientDetails country label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Please select country", description: "PatientDetails country select placeholder" })}
            path='patientInfo.address.country'
            options={countryList}
            mandatory
            onChange={(val) => {
              var states = getFormattedStates(val)
              if(states.length > 0){
                if(states.findIndex(x => x === form.getValue('patientInfo.address.state')) == -1){
                  form.setValue('patientInfo.address.state', null)
                }
              }
            }}
          /></ComboboxContainer>
          <FormValue path="patientInfo.address.country">{country => 
            <ComboboxContainer readOnly={readOnly} className='fs-exclude'>
              <Combobox
                disabled={readOnly}
                className="combobox fs-exclude"
                label={intl.formatMessage({ defaultMessage: "State/Province", description: "PatientDetails state label" })}
                placeholder={intl.formatMessage({ defaultMessage: "Please select state", description: "PatientDetails state select placeholder" })}
                mandatory
                path='patientInfo.address.state'
                options={getFormattedStates(country)}
                // onChange={(val) => setRegion(val)}
              />
            </ComboboxContainer>
          }</FormValue>
        </> : 
        <>
          <TextInput
            disabled={readOnly}
            type="text"
            path="patientInfo.address.country"
            label={intl.formatMessage({ defaultMessage: "Country", description: "PatientDetails country label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: USA", description: "PatientDetails country placeholder" })}
            maxLength={255}
            mandatory
          />
          <TextInput
            disabled={readOnly}
            type="text"
            path="patientInfo.address.state"
            label={intl.formatMessage({ defaultMessage: "State", description: "PatientDetails state label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: New York", description: "PatientDetails state placeholder" })}
            maxLength={255}
            mandatory
          />
        </>}
      </SplitColumnsContainer>
      {isAdmin && acceptedJurisdictions && showSelects && acceptedJurisdictions.length > 0 && <FormValue path="patientInfo.address.country">{country => <>
        <FormValue path="patientInfo.address.state">{state => {
          return <>
            <div>{acceptedJurisdictions.find(jurisdiction => jurisdiction.country === country && jurisdiction.states.includes(state)) 
              ? null
              : (country != '' && state != '' && state != null && state != undefined && 
                  // <InfoBox lightYellow style={{marginTop: '0.75rem', marginBottom: '1.5rem'}}>Attention: <b>{state} - {country}</b> is not within your accepted jurisdictions.</InfoBox>
                  <InfoBox lightYellow style={{marginTop: '0.75rem', marginBottom: '1.5rem'}}>
                    {intl.formatMessage(
                      {
                        defaultMessage: "Attention : {state} - {country} is not within your accepted jurisdictions.",
                        description: "PatientDetails attention message with state and country",
                      },
                      { state, country } // Pass dynamic values here
                    )}
                  </InfoBox>
                )
            }</div>
          </>
        }}</FormValue>
      </>}</FormValue>}
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.address.city"
          label={intl.formatMessage({ defaultMessage: "City", description: "PatientDetails city label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: New York", description: "PatientDetails city placeholder" })}
          maxLength={255}
          mandatory
        />
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.address.zipCode"
          label={intl.formatMessage({ defaultMessage: "Postal code", description: "PatientDetails postal code label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: 12345", description: "PatientDetails postal code placeholder" })}
          maxLength={255}
          mandatory
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.address.address"
          label={intl.formatMessage({ defaultMessage: "Street address - Line 1", description: "PatientDetails street address line 1 label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: 001 Street Name", description: "PatientDetails street address line 1 placeholder" })}
          maxLength={255}
          mandatory
        />
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.address.address2"
          label={intl.formatMessage({ defaultMessage: "Street address - Line 2", description: "PatientDetails street address line 2 label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: PO BOX 001", description: "PatientDetails street address line 2 placeholder" })}
          maxLength={255}
        />
      </SplitColumnsContainer>
      {isPatientCreating && !captchaEnabled && <div aria-hidden="true" className="alternate-address"><TextInput
        disabled={readOnly}
        type="text"
        path="patientInfo.alternateAddress"
        label=" "
        placeholder="Ex: 001 Street Name"
        maxLength={255}
        autoComplete="Xas9d0a9sda20asdo82oasd921ada"
        // className="alternate-address"
        tabIndex="-1"
      /></div>}
      
      {/* Current */}
      {/* <TextInput
        disabled={readOnly}
        type="text"
        path="patientInfo.address.address"
        label="Street address"
        placeholder="Ex: 001 Street Name"
        maxLength={255}
        mandatory
      />
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.address.city"
          label="City"
          placeholder="Ex: New York"
          maxLength={255}
          mandatory
        />
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.address.state"
          label="State"
          placeholder="Ex: New York"
          maxLength={255}
          mandatory
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.address.country"
          label="Country"
          placeholder="Ex: USA"
          maxLength={255}
          mandatory
        />
        <TextInput
          disabled={readOnly}
          type="text"
          path="patientInfo.address.zipCode"
          label="Postal code"
          placeholder="Ex: 12345"
          maxLength={255}
          mandatory
        />
      </SplitColumnsContainer> */}
    </Card>
  </>
}
